import * as React from 'react';
import { ArrowScrolldown24 } from '@cian/ui-kit';
import * as styles from './styles.css';

export const ArrowDownButton = ({ onClick }: { onClick(): void }) => {
  return (
    <button className={styles['arrow']} onClick={onClick}>
      <ArrowScrolldown24 color="white_100" />
    </button>
  );
};
